/** ***********
*
* <esri-query.service.ts v1.0>
*
* Copyright (c) 2023 AIRBUS OPERATIONS
*
* Contributors:
*  GARY Adrien (NG635E8) [adrien.gary.external@airbus.com]
*
* All rights reserved.
**************/

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EsriBeacon } from 'src/app/models/beacon';
import { environment } from 'src/environments/environment';

interface EsriQuery<T> {
  exceededTransferLimit: boolean;
  features: T[];
  fields: any[];
  geometryType: string;
  globalIdFieldName: string;
  hasM: boolean;
  hasZ: boolean;
  objectIdFieldName: string;
  spatialReference: {
    latestWkid: number;
    wkid: number;
  };
}

@Injectable({
    providedIn: 'root'
})
export class EsriQueryService {

    constructor(private http: HttpClient) { }

    /**
     *  return all the assets on which the user has rights
     */
    public getAssets(): Observable<any> {
        return this.http.get(
            `${environment.API_ENDPOINT}/esri/query/asset`
        ).pipe(map(data => data as any));
    }

    /**
     * return beacons in the map
     */
    public getBeacons(): Observable<EsriQuery<EsriBeacon>> {
      return this.http.get<EsriQuery<EsriBeacon>>(
        `${environment.API_ENDPOINT}/esri/query/beacon`
      );
    }

    /**
     * Get esri map
     */
    public getEsriMap(): Observable<any> {
        return this.http.get(
            `${environment.API_ENDPOINT}/esri/map`
        ).pipe(map(data => data as any));
    }
}
